import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import LockProcedure from "../../../../../../../../../Components/Clients/Timeline/LockProcedure";
import { QUERY_KEYS } from "../../../../../../../../../consts/api";

export function Lock({ isLock, procedureId }) {
  if (!procedureId) {
    return null;
  }
  const queryClient = useQueryClient();

  return (
    <LockProcedure
      isdocuments
      isLocked={isLock}
      procedureId={procedureId}
      refetchProcedures={() => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.all],
        });
      }}
    />
  );
}
